import * as React from 'react';
import GenericModal from '../../genericModal/genericModal';
import './ClientPhoneNumberModal.css';

interface IClientPhoneNumberModal {
  isOpen: boolean;
  okayClick: () => void;
}

class ClientPhoneNumberModal extends React.Component<IClientPhoneNumberModal> {
  public render(): JSX.Element {
    return (
      <GenericModal modalWindowId="ClientPhoneNumberModal" title="Help and support" isOpen={this.props.isOpen} primaryButtonText="OK" primaryButtonAction={this.props.okayClick}>
        <div><p className="udf-body-copy-normal needHelp">
          If you need help, please call our servicing team.
                </p>
          <p>
            <span className="phoneNumber">0345 600 7433</span> <span className="outsideUkPhoneNumber">
              (+44 207 412 8463 from outside the UK)
                </span>
          </p>
          <p className="udf-body-copy-normal openingHours">
            Mon - Fri: 08:00 - 18:00
                </p></div>
      </GenericModal>
    );
  }
}

export default ClientPhoneNumberModal;



// WEBPACK FOOTER //
// ./src/components/shared/header/client/ClientPhoneNumberModal.tsx